<template>
    <content-toggle toggle="Reklamationen" is-toggled="1">
        <div class="row">
            <div class="col col-6">
                <client-complaint :ask-for-quote="askForQuote" :admin-users="adminUsers"
                                  @forwardClientComplaint="forwardClientComplaintEvent"/>
            </div>
            <div class="col col-6">
                <producer-complaint :ask-for-quote="askForQuote" :admin-users="adminUsers"
                                    :producer-complaint-modal-prop="producerComplaintModal"
                                    :edit-producer-complaint-prop="editProducerComplaint"
                                    :forward-client-complaint-prop="forwardClientComplaint" @closeDialog="producerComplaintModal = false; editProducerComplaint = null; forwardClientComplaint = false; "/>
            </div>
        </div>
    </content-toggle>
</template>

<script>
import ContentToggle from '@partfactory/Shared/Elements/ContentToggle';
import ClientComplaint from '@partfactory/Pages/Admin/AskForQuote/OrderInformations/ClientComplaint';
import ProducerComplaint from '@partfactory/Pages/Admin/AskForQuote/OrderInformations/ProducerComplaint';

export default {
    name: 'Complaint',
    components: {
        ProducerComplaint,
        ClientComplaint,
        ContentToggle
    },
    props: {
        askForQuote: Object,
        adminUsers: Object,
    },
    data() {
        return {
            clientComplaintModal: false,
            editClientComplaint: null,
            forwardClientComplaint: null,
            producerComplaintModal: false,
            editProducerComplaint: null,
        };
    },
    methods: {
        forwardClientComplaintEvent(clientComplaint) {
            this.producerComplaintModal = true;
            this.editProducerComplaint = clientComplaint;
            this.forwardClientComplaint = true;
        },
    },
};
</script>
